import { StyleType, VariantType } from '@nx-smartmonkey/ui';
import React, { useState } from 'react';
import { useRetrieveActivePlan } from '../../hooks/plan/useRetrieveActivePlan';

import { DriversFromVehiclesDialog } from '../../pages/planner/plan-details/dialogs/DriversFromVehiclesDialog';
import Button from '../../react-components/Button';
import Text from '../../react-components/Text';

type DriversCreateMenuProps = {
  id?: string;
  style?: React.CSSProperties;
  variant?: VariantType;
  styleType?: StyleType;
  intlId?: string;
  intlValues?: Record<string, string | number | ((chunks: any) => React.ReactElement)>;
};

const DriversCreateMenu = ({ id, style, variant, styleType, intlId }: DriversCreateMenuProps) => {
  const [routesFromVehiclesOpen, setRoutesFromVehiclesOpen] = useState<boolean | undefined>(false);
  const { data: plan } = useRetrieveActivePlan();
  return (
    <>
      <Button
        id={id}
        style={style}
        variant={variant}
        styleType={styleType}
        onClick={() => setRoutesFromVehiclesOpen(true)}
      >
        <Text intlId={intlId ?? `plans.plan.data.routes.add_new`} style={{ color: `white`, cursor: `pointer` }} />
      </Button>

      <DriversFromVehiclesDialog
        planId={plan!.id}
        open={Boolean(routesFromVehiclesOpen)}
        handleCloseDialog={(e: any) => {
          if (e) e.stopPropagation();
          setRoutesFromVehiclesOpen(false);
        }}
      />
    </>
  );
};

export default DriversCreateMenu;
